// Module
var code = `talentExpertHiringFunnelComponent`;
// Exports
export default code;